import React, { useEffect, useState } from "react";
import Rating from "@mui/material/Rating";
import Button from "@mui/material/Button";
import { useParams, useNavigate } from "react-router-dom";
import { decrypt } from "../../helpers/utilities";
import { URLS } from "../../helpers/URLS";
import useAxios from "../../helpers/Hooks/useAxios";
import { toast } from "react-toastify";
import { downloadLink } from '../../helpers/constFIles';
import { TextField, FormControl, MenuItem, InputLabel } from "@mui/material"
import Select from "@mui/material/Select"
import ResumeViewModal from "./ResumeViewModal";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import PauseCircleOutlineOutlinedIcon from "@mui/icons-material/PauseCircleOutlineOutlined";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import DoNotDisturbAltOutlinedIcon from "@mui/icons-material/DoNotDisturbAltOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import AlternateEmailOutlinedIcon from "@mui/icons-material/AlternateEmailOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined";
import FlightTakeoffOutlinedIcon from "@mui/icons-material/FlightTakeoffOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import Tooltip from "@mui/material/Tooltip";
import "../../assets/scss/tables.scss";

const initials = (name) => {
  if (!name) return "?";
  const parts = String(name).trim().split(/\s+/);
  return ((parts[0] ? parts[0][0] : "") +
    (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
};

const Fact = ({ icon, label, value }) => (
  <div className="wh-fact">
    <span className="wh-fact-icon">{icon}</span>
    <div className="wh-fact-text">
      <span className="wh-fact-label">{label}</span>
      <span className="wh-fact-value">{value || "--"}</span>
    </div>
  </div>
);

const Interviewer = () => {
  
  const { candidateID, interViewID, scheduledTo } = useParams();

  const navigate = useNavigate();
 
  const { fetchData } = useAxios();
 
  const [resumeShow, setResumeShow] = useState(false);
 
  const [resumeView, setResumeView] = useState({
    filePath: "",
    filetype: "",
    resumeName: ""
  })
  
  const [candidate, setCandidate] = useState({
    jobPosition: {
      createdDate: "",
      employeeID: "",
      experienceFrom: "",
      experienceTo: "",
      isActive: false,
      jobJDID: "",
      jobTitle: "",
      requirements: "",
      skills: "",
      _id: "",
    },
    interView: {
      review: [],
      _id: "",
      candidateID: "",
      comments: "",
      createdDate: "",
      employeeID: "",
      startTime: "",
      endTime: "",
      interViewID: "",
      isActive: null,
      roundType: "",
      status: "",
    },
    candidate: {
      AADHAR: "",
      PAN: "",
      candidateID: "",
      comments: [],
      currentCTC: "",
      email: "",
      employeeID: "",
      expectedCTC: "",
      experience: "",
      isActive: "",
      isSelected: "",
      jobJD: "",
      name: "",
      noticePeroid: null,
      phone: "",
      resumeUrl: "",
      skills: "",
      willJoinEarly: null,
    },
  });

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const CID = decrypt(candidateID);
      const IID = decrypt(interViewID);
      const EID = decrypt(scheduledTo);
      const resp = await fetchData({
        url: URLS.getInterViewData(CID, IID, EID),
        method: "get",
      });
      if (resp.status === 200) {
        let candi = resp.data;
        if (candi.interView.roundType === 'Hr') {
          candi.interView.review = [
            {
              "label": "Communication skill",
              "rating": 3,
              "value": ""
            },
            {
              "label": "comment",
              "rating": 0,
              "value": "Good"
            }
          ]
        }
        setCandidate(candi);
      }
    } catch (err) { }
  };

  const candidateResume = (data) => {
    setResumeView({
      ...resumeView,
      filePath: downloadLink + data.candidate.resumeUrl,
      filetype: data.candidate.resumeUrl.split(".").at(-1),
      resumeName: data.candidate.name
    })
    setResumeShow(true);
  }
  
  const resumeHide = () => {
    setResumeShow(false)
  }

  /* Each outcome carries its own icon and colour, so the decision reads at a
     glance in the closed field as well as in the open list — this is the one
     field on the page somebody scans for afterwards. */
  const roundOptions = [
    {
      value: "Selected", label: "Selected", tone: "is-good",
      Icon: HowToRegOutlinedIcon, hint: "Ready for an offer",
    },
    {
      value: "Move to Next Round", label: "Move to Next Round", tone: "is-next",
      Icon: ArrowCircleRightOutlinedIcon, hint: "Passed — send to the next panel",
    },
    {
      value: "Hold", label: "Hold", tone: "is-hold",
      Icon: PauseCircleOutlineOutlinedIcon, hint: "Park the decision for now",
    },
    {
      value: "Rejected", label: "Rejected", tone: "is-bad",
      Icon: DoNotDisturbAltOutlinedIcon, hint: "Not going forward",
    },
  ];

  const c = candidate.candidate || {};
  const job = candidate.jobPosition || {};
  const review = candidate.interView?.review || [];
  const locked = Boolean(candidate.interView?.isLock);

  const splitSkills = (value) =>
    String(value || "").split(",").map((x) => x.trim()).filter(Boolean);

  const skills = splitSkills(c.skills);
  const roleSkills = splitSkills(job.skills);

  /* matched on a case-insensitive comparison, so "React" and "react" line up */
  const roleSet = new Set(roleSkills.map((x) => x.toLowerCase()));
  const candidateSet = new Set(skills.map((x) => x.toLowerCase()));
  const matchedCount = roleSkills.filter((x) => candidateSet.has(x.toLowerCase())).length;

  /* the criteria that carry a score, so the average reflects only those */
  const scored = review.filter((x) => x.label !== "comment");
  const commentIndex = review.findIndex((x) => x.label === "comment");
  const given = scored.filter((x) => x.rating);
  const average = given.length
    ? (given.reduce((sum, x) => sum + Number(x.rating || 0), 0) / given.length).toFixed(1)
    : null;

  return (
    <div className="wh-table wh-profile-page assess-page">

      <div className="wh-toolbar">
        <Tooltip title="Go back" placement="bottom" arrow>
          <button type="button" className="wh-back-btn" onClick={() => navigate(-1)}
            aria-label="Go back">
            <ArrowBackRoundedIcon />
          </button>
        </Tooltip>
        <h4 className="title">Give Rating to {c.name || "candidate"}</h4>

        <div className="wh-toolbar-controls wh-toolbar-controls--end">
          <Button variant="outlined" startIcon={<DescriptionOutlinedIcon />}
            disabled={!c.resumeUrl}
            onClick={() => candidateResume(candidate)}>
            {c.resumeUrl ? "Resume" : "No resume"}
          </Button>
        </div>
      </div>

      {locked && (
        <div className="wh-note assess-locked">
          <LockOutlinedIcon />
          <p>This assessment has been submitted and can no longer be changed.</p>
        </div>
      )}

      <div className="wh-panel">
        <div className="wh-profile-hero">
          <div className="wh-avatar">{initials(c.name)}</div>
          <div className="wh-profile-id">
            <h5>{c.name || "--"}</h5>
            <p>{job.jobTitle || "No position linked"}</p>
          </div>
          <span className="wh-pill wh-profile-code">{c.candidateID}</span>
        </div>

        <div className="wh-facts-grid">
          <Fact icon={<AlternateEmailOutlinedIcon />} label="Email" value={c.email} />
          <Fact icon={<LocalPhoneOutlinedIcon />} label="Phone" value={c.phone} />
          <Fact icon={<TimelineOutlinedIcon />} label="Experience"
            value={c.experience ? `${c.experience} Years` : "Fresher"} />
          <Fact icon={<PaidOutlinedIcon />} label="CTC (current → expected)"
            value={c.currentCTC || c.expectedCTC
              ? `${c.currentCTC || "--"} → ${c.expectedCTC || "--"} LPA`
              : ""} />
          <Fact icon={<EventBusyOutlinedIcon />} label="Notice Period"
            value={c.noticePeroid ? `${c.noticePeroid} Days` : ""} />
          <Fact icon={<FlightTakeoffOutlinedIcon />} label="Will Join Early"
            value={c.willJoinEarly ? `${c.willJoinEarly} Days` : ""} />
          <Fact icon={<WorkOutlineOutlinedIcon />} label="Position" value={job.jobTitle} />
        </div>

        <div className="skills-compare">
          <div className="skills-col">
            <h6 className="wh-section-title" style={{ marginTop: 14 }}>
              <PsychologyOutlinedIcon />Candidate Skills
            </h6>
            {skills.length > 0
              ? <div className="wh-pills">
                {skills.map((skill, index) => (
                  <span key={index}
                    className={`wh-pill ${roleSet.has(skill.toLowerCase()) ? 'wh-pill-good' : ''}`}>
                    {roleSet.has(skill.toLowerCase()) && <CheckRoundedIcon />}
                    {skill}
                  </span>
                ))}
              </div>
              : <p className="wh-section-empty">No skills recorded for this candidate.</p>}
          </div>

          <div className="skills-col">
            <h6 className="wh-section-title" style={{ marginTop: 14 }}>
              <WorkOutlineOutlinedIcon />Skills the Role Needs
              {roleSkills.length > 0 && (
                <span className={`skills-score ${matchedCount === roleSkills.length ? 'is-full' : ''}`}>
                  {matchedCount}/{roleSkills.length} matched
                </span>
              )}
            </h6>
            {roleSkills.length > 0
              ? <div className="wh-pills">
                {roleSkills.map((skill, index) => {
                  const has = candidateSet.has(skill.toLowerCase());
                  return (
                    <span key={index} className={`wh-pill ${has ? 'wh-pill-good' : 'wh-pill-missing'}`}>
                      {has ? <CheckRoundedIcon /> : <CloseRoundedIcon />}
                      {skill}
                    </span>
                  );
                })}
              </div>
              : <p className="wh-section-empty">No skills listed on this job.</p>}
          </div>
        </div>
      </div>

      <div className="wh-panel assess-panel">
        <div className="assess-head">
          <h6 className="wh-section-title" style={{ margin: 0 }}>
            <RateReviewOutlinedIcon />Assessment
          </h6>
        </div>

        {/* the decision and the summary sit together: they are the two things
            that actually get read afterwards */}
        <div className="assess-decision">
          <FormControl size="small" className="assess-recommend">
            <InputLabel id="round-type">Recommendation</InputLabel>
            <Select labelId="round-type" id="round-type" label="Recommendation"
              value={candidate.interView.status}
              name="roundType"
              disabled={locked}
              /* the hint line belongs in the list, not in the closed field */
              renderValue={(value) => {
                const opt = roundOptions.find((o) => o.value === value);
                if (!opt) return "";
                return (
                  <span className={`assess-chosen ${opt.tone}`}>
                    <opt.Icon />
                    {opt.label}
                  </span>
                );
              }}
              onChange={(e) => {
                const temp = { ...candidate };
                temp.interView.status = e.target.value;
                setCandidate(temp);
              }}
            >
              {roundOptions.map((opt) => (
                <MenuItem key={opt.value} value={opt.value} className={`assess-option ${opt.tone}`}>
                  <opt.Icon />
                  <span>
                    {opt.label}
                    <em>{opt.hint}</em>
                  </span>
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {commentIndex > -1 && (
            <TextField
              fullWidth
              multiline
              minRows={2}
              size="small"
              disabled={locked}
              className="assess-overall"
              label="Overall comment"
              placeholder="Anything the panel should know"
              value={review[commentIndex].value || ""}
              onChange={(e) => {
                const temp = { ...candidate };
                temp.interView.review[commentIndex].value = e.target.value;
                setCandidate(temp);
              }}
            />
          )}

          {/* the score the criteria below add up to */}
          <div className={`assess-average ${average ? '' : 'is-empty'}`}>
            <span className="assess-average-label">Overall rating</span>
            <span className="assess-average-score">
              <StarRoundedIcon />
              <b>{average || "--"}</b>
              <em>/ 5</em>
            </span>
            <span className="assess-average-meta">
              {given.length} of {scored.length} rated
            </span>
          </div>
        </div>

        <div className="assess-grid">
          {review.map((x, index) => x.label === "comment" ? null : (
            <div className="assess-card" key={index}>
              <div className="assess-card-head">
                <span className="assess-label">{x.label}</span>

                {x.label !== "comment" && (
                  <span className="wh-rating">
                    <Rating
                      name={`rating-${index}`}
                      value={Number(x.rating) || 0}
                      size="medium"
                      disabled={locked}
                      emptyIcon={<StarRoundedIcon style={{ opacity: 1 }} fontSize="inherit" />}
                      icon={<StarRoundedIcon fontSize="inherit" />}
                      onChange={(event, newValue) => {
                        const temp = { ...candidate };
                        temp.interView.review[index].rating = newValue;
                        setCandidate(temp);
                      }}
                    />
                    <b>{x.rating ? `${x.rating}/5` : "--"}</b>
                  </span>
                )}
              </div>

              <TextField
                fullWidth
                multiline
                minRows={2}
                size="small"
                disabled={locked}
                label={x.label === "comment" ? "Overall comment" : "Notes"}
                placeholder={x.label === "comment"
                  ? "Anything the panel should know"
                  : `What stood out on ${x.label}?`}
                value={x.value || ""}
                onChange={(e) => {
                  const temp = { ...candidate };
                  temp.interView.review[index].value = e.target.value;
                  setCandidate(temp);
                }}
              />
            </div>
          ))}
        </div>

        <div className="assess-foot">
          <Button
            disabled={locked}
            variant="contained"
            startIcon={<SaveRoundedIcon />}
            onClick={async (e) => {
              const { status, message } = await fetchData({
                url: URLS.updateReview,
                method: "post",
                body: candidate.interView,
              });
              if (status === 200) {
                toast.success(message);
                getData();
              } else {
                toast.error(message, "error");
              }
            }}
          >
            Save Assessment
          </Button>
        </div>
      </div>

      <ResumeViewModal
        resumeData={resumeView}
        show={resumeShow}
        onHide={resumeHide}
      />
    </div>
  );
};

export default Interviewer;
